(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["car-model-search"] && !Shopify.designMode) return;
  try {
    (function () {
    var trigger = document.querySelector('[data-car-search-trigger]');
    var overlay = document.querySelector('[data-car-search]');
    var dialog = document.querySelector('[data-car-search-dialog]');
    var input = document.querySelector('[data-car-search-input]');
    var results = document.querySelector('[data-car-search-results]');
    var status = document.querySelector('[data-car-search-status]');
    var modelNode = document.querySelector('[data-car-search-models]');
    if (!trigger || !overlay || !dialog || !input || !results || !status || !modelNode) return;

    var models = [];
    try { models = JSON.parse(modelNode.textContent) || []; } catch (error) { models = []; }

    function slug(value) { return String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
    function cleanModelName(value, brandHandle) {
      var name = String(value || '').replace(/[\u2013\u2014]/g, '-').replace(/\s+/g, ' ').trim();
      name = name.replace(/\s+(?:19|20)\d{2}\s*-\s*(?:19|20)\d{2}$/i, '').replace(/\s+(?:19|20)\d{2}$/i, '');
      if (brandHandle) name = name.replace(new RegExp('^(?:' + String(brandHandle).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')\\s+', 'i'), '');
      return name.replace(/\s+/g, ' ').trim();
    }
    function ranges(value) { return String(value || '').replace(/[\u2013\u2014]/g, '-').split(',').map(function (item) { return item.trim(); }).filter(Boolean); }
    function openSearch() { overlay.hidden = false; document.body.style.overflow = 'hidden'; input.value = ''; render(''); window.setTimeout(function () { input.focus(); }, 0); }
    function closeSearch() { overlay.hidden = true; document.body.style.overflow = ''; trigger.focus(); }
    function render(value) {
      var query = String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
      results.innerHTML = '';
      if (!query) { status.textContent = 'Search by brand or model name.'; return; }
      var matches = [];
      models.forEach(function (model) {
        var brand = String(model.brandName || '').trim();
        var cleaned = cleanModelName(model.name, model.brandHandle);
        var haystack = (String(model.name || '') + ' ' + brand + ' ' + brand + ' ' + cleaned).toLowerCase();
        if (haystack.indexOf(query) === -1) return;
        ranges(model.yearRange).forEach(function (yearRange) { matches.push({ model: model, brand: brand, name: cleaned, year: yearRange }); });
      });
      status.textContent = matches.length + (matches.length === 1 ? ' result found' : ' results found');
      if (!matches.length) { results.innerHTML = '<p class="ad-car-search__status">No matching cars found.</p>'; return; }
      matches.forEach(function (match) {
        var link = document.createElement('a');
        link.className = 'ad-car-search__result';
        link.href = '/pages/car-results?brand=' + encodeURIComponent(String(match.model.brandHandle || '')) + '&model=' + encodeURIComponent(slug(match.name)) + '&year=' + encodeURIComponent(String(match.year).replace(/\s+/g, ''));
        var image = match.model.image ? '<img class="ad-car-search__image" src="' + match.model.image + '" alt="" loading="lazy">' : '<span class="ad-car-search__image ad-car-search__image--empty" aria-hidden="true">⌁</span>';
        link.innerHTML = image + '<span><span class="ad-car-search__brand">' + match.brand.replace(/</g, '&lt;') + '</span><span class="ad-car-search__model">' + match.name.replace(/</g, '&lt;') + '</span><span class="ad-car-search__year">' + match.year.replace(/</g, '&lt;') + '</span></span>';
        results.appendChild(link);
      });
    }
    trigger.addEventListener('click', function () { openSearch(); });
    overlay.querySelectorAll('[data-car-search-close]').forEach(function (node) { node.addEventListener('click', closeSearch); });
    input.addEventListener('input', function () { render(input.value); });
    document.addEventListener('keydown', function (event) { if (!overlay.hidden && event.key === 'Escape') closeSearch(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["car-results-content"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var root = document.querySelector('.car-results');
    if (!root) return;

    // Customer-facing shade names and prices stay static in PKR. Live
    // Shopify product data is still used below for images, descriptions and
    // variant IDs so Add to Cart continues to work normally.
    var staticShadeDetails = {
      full: { name: '4-Side (Full Window Coverage Sunshades)', amount: 2799 },
      half: { name: '4-Side (Half Window Coverage Sunshades)', amount: 2799 },
      front: { name: 'Front Window Shield', amount: 3800 },
      rear: { name: 'Rear Window Shield', amount: 2800 }
    };

    function staticShadeName(shadeKey) {
      return staticShadeDetails[shadeKey] ? staticShadeDetails[shadeKey].name : '';
    }

    function staticShadePrice(shadeKey, qty) {
      var details = staticShadeDetails[shadeKey];
      var total = details ? details.amount * (qty || 1) : 0;
      return 'Rs. ' + total.toLocaleString('en-US');
    }

    var params = new URLSearchParams(window.location.search);
    var brandParam = (params.get('brand') || '').trim().toLowerCase();
    var modelParam = (params.get('model') || '').trim();
    var yearParam = parseInt(params.get('year'), 10) || 0;

    // ------------------------------------------------------------------
    // Name helpers - intentionally mirror shop-by-car-models.liquid so the
    // `model` slug arriving in the URL can be resolved against the exact
    // same cleaned model names that generated it.
    // ------------------------------------------------------------------
    function escapeRegExp(value) {
      return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function slug(value) {
      return String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    function normalizeRange(value) {
      return String(value || '').replace(/[\u2013\u2014]/g, '-').replace(/\s+/g, ' ').trim();
    }

    function normalizeName(value) {
      return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    }

    var brandPrefixes = {};
    if (brandParam) brandPrefixes[brandParam] = true;

    function cleanModelName(value) {
      var name = String(value || '').replace(/[\u2013\u2014]/g, '-').replace(/\s+/g, ' ').trim();
      name = name.replace(/\s+(?:19|20)\d{2}\s*-\s*(?:19|20)\d{2}$/i, '');
      name = name.replace(/\s+(?:19|20)\d{2}$/i, '');
      if (Object.keys(brandPrefixes).length) {
        var prefixRe = new RegExp('^(?:' + Object.keys(brandPrefixes).map(escapeRegExp).join('|') + ')\\s+', 'i');
        name = name.replace(prefixRe, '');
      }
      return name.replace(/\s+/g, ' ').trim();
    }

    function parseRange(value) {
      var parts = normalizeRange(value).split('-');
      var start = parseInt(parts[0], 10) || 0;
      var end = parseInt(parts[parts.length - 1], 10) || start;
      return { start: start, end: end };
    }

    function readIsland(selector) {
      var node = document.querySelector(selector);
      if (!node) return [];
      try {
        var parsed = JSON.parse(node.textContent);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    var brands = readIsland('[data-car-results-brands]');
    var models = readIsland('[data-car-results-models]');

    // Front/Rear availability - client controlled from Shopify Admin only.
    // Each model in the island carries `frontWindshieldShade` /
    // `rearWindshieldShade` (true | false | null) mapped from the Car Model
    // metaobject boolean fields `front_windshield_shade` /
    // `rear_windshield_shade`. There is no hardcoded vehicle allowlist: those
    // Admin fields are the single source of truth for Front/Rear availability.

    // Cached copies of the Shopify product data islands so the submit handler
    // can resolve the live variant id deterministically - even if the async
    // attribute-hydration pass has not run yet (or did not match).
    var compatIslandData = (function () {
      var node = document.querySelector('[data-car-compat-test]');
      if (!node) return {};
      try { return JSON.parse(node.textContent) || {}; } catch (error) { return {}; }
    })();

    var universalIslandData = (function () {
      var node = document.querySelector('[data-car-results-universal]');
      if (!node) return {};
      try { return JSON.parse(node.textContent) || {}; } catch (error) { return {}; }
    })();

    // ------------------------------------------------------------------
    // Resolve the selected car from brand/model/year parameters.
    //
    // shop-by-car-models builds links as:
    //   ?brand=<handle>&model=<slug(cleanModelName(name))>&year=<rangeStart>
    // so here we reconstruct cleanName per record, slug it, and compare -
    // using the same prefix/year stripping and case/space normalisation.
    // ------------------------------------------------------------------
    var brandRecord = null;
    for (var i = 0; i < brands.length; i++) {
      if (String(brands[i].handle || '').toLowerCase() === brandParam) {
        brandRecord = brands[i];
        break;
      }
    }

    if (brandRecord && brandRecord.name) {
      brandPrefixes[String(brandRecord.name).trim().toLowerCase()] = true;
      models.forEach(function (model) { model.cleanName = cleanModelName(model.name); });
    }

    var matchingModels = [];
    if (brandParam) {
      models.forEach(function (model) {
        if (String(model.brand || '').toLowerCase() !== brandParam || !model.cleanName) return;
        if (modelParam && slug(model.cleanName) !== modelParam) return;
        matchingModels.push(model);
      });
    }

    matchingModels.sort(function (a, b) {
      var aRange = parseRange(a.yearRange);
      var bRange = parseRange(b.yearRange);
      if (!yearParam) return bRange.end - aRange.end;
      var aDist = Math.min(Math.abs(aRange.start - yearParam), Math.abs(aRange.end - yearParam));
      var bDist = Math.min(Math.abs(bRange.start - yearParam), Math.abs(bRange.end - yearParam));
      if (aDist !== bDist) return aDist - bDist;
      return normalizeRange(a.yearRange).localeCompare(normalizeRange(b.yearRange));
    });

    var selectedModel = matchingModels[0] || null;

    // ------------------------------------------------------------------
    // Dynamic Full/Half shade cards - driven by the Shopify product
    // metafield custom.compatible_car_models.
    //
    // The store may expose several Full and several Half products, each
    // wired to a different generation range through that metafield. The
    // compatible entry for a shade role is the first candidate product whose
    // referenced car model ids include the resolved selected model id. That
    // entry's image, title, price and description are swapped onto the card
    // from the live Shopify product data. If no candidate references the
    // selected model the static card is left exactly as it is.
    // ------------------------------------------------------------------
    function matchedCompatEntry(shadeKey) {
      if (!compatIslandData || !selectedModel) return null;
      if (selectedModel.id === undefined || selectedModel.id === null) return null;

      var selectedId = String(selectedModel.id);
      var roleData = compatIslandData[shadeKey];
      if (!roleData) return null;

      var candidates = (roleData.candidates && roleData.candidates.length) ? roleData.candidates : [];
      for (var c = 0; c < candidates.length; c++) {
        if ((candidates[c].compatibleModels || []).some(function (ref) {
          return String(ref.id) === selectedId;
        })) {
          return candidates[c];
        }
      }
      return null;
    }

    function selectedVehicleLabel() {
      if (!selectedModel) return '';
      var brandName = brandRecord && brandRecord.name ? String(brandRecord.name).trim() : '';
      var modelName = selectedModel.cleanName || selectedModel.name || '';
      var years = selectedModel.yearRange ? normalizeRange(selectedModel.yearRange) : '';
      var vehicle = [brandName, modelName].filter(Boolean).join(' ');
      return vehicle + (years ? ' (' + years + ')' : '');
    }

    // Vehicle product variants use the model/year value without the brand
    // prefix. Keep this separate from selectedVehicleLabel(), which is also
    // used by the existing Full/Half matching and cart diagnostics.
    function selectedVehicleOptionLabel() {
      if (!selectedModel) return '';
      var modelName = selectedModel.cleanName || selectedModel.name || '';
      var years = selectedModel.yearRange ? normalizeRange(selectedModel.yearRange) : '';
      return modelName + (years ? ' (' + years + ')' : '');
    }

    function normalizeVehicleOption(value) {
      return normalizeRange(value).replace(/\s*-\s*/g, '-').replace(/\s+/g, ' ').trim();
    }

    function matchedVehicleVariant(entry) {
      var expected = selectedVehicleLabel();
      if (!expected || !entry || !Array.isArray(entry.variants)) return null;

      var normalizedExpected = normalizeVehicleOption(expected);
      for (var v = 0; v < entry.variants.length; v++) {
        var variant = entry.variants[v];
        var optionValues = [variant.option1, variant.option2, variant.option3];
        for (var o = 0; o < optionValues.length; o++) {
          if (optionValues[o] && normalizeVehicleOption(optionValues[o]) === normalizedExpected) {
            return variant;
          }
        }
      }
      return null;
    }

    function matchedUniversalVehicleVariant(entry) {
      var expected = selectedVehicleOptionLabel();
      if (!expected || !entry || !Array.isArray(entry.variants)) return null;
      var normalizedExpected = normalizeVehicleOption(expected);
      for (var v = 0; v < entry.variants.length; v++) {
        if (entry.variants[v].vehicleValue && normalizeVehicleOption(entry.variants[v].vehicleValue) === normalizedExpected) {
          return entry.variants[v];
        }
      }
      return null;
    }

    // Front/Rear availability decision - driven exclusively by the
    // client-editable car_model boolean fields (Admin: Content > Metaobjects >
    // Car Model > "Front Windshield Shade" / "Rear Windshield Shade"):
    //   field TRUE  -> shade offered (an exact matching Front/Rear vehicle
    //                  variant is still required - no fallback to another
    //                  vehicle's variant)
    //   field FALSE -> Out of Stock regardless of variant inventory
    //   field unset (null) -> Out of Stock (no hardcoded fallback)
    // Front and Rear are evaluated independently.
    function frontRearEnabledFor(model, shadeKey) {
      if (!model) return false;
      var adminField = shadeKey === 'front' ? model.frontWindshieldShade : model.rearWindshieldShade;
      return adminField === true;
    }

    function renderDynamicShades() {
      ['full', 'half'].forEach(function (shadeKey) {
        var entry = matchedCompatEntry(shadeKey);
        if (!entry) return;

        var button = root.querySelector('[data-shade-key="' + shadeKey + '"]');
        if (!button) return;

        // Record the live entry so the selection handler can reuse it
        // (description + currency-aware price).
        dynamicShades[shadeKey] = entry;
        stockModes[shadeKey] = availabilityMode(entry);

        button.setAttribute('data-shade-name', staticShadeName(shadeKey));
        button.setAttribute('data-shade-price', staticShadePrice(shadeKey, 1));
        if (entry.image) button.setAttribute('data-shade-image', entry.image);
        // Prefer a confirmed buyable variant (scanned from the variant list,
        // then first_available_variant) over the default variant so a
        // sold-out first/default variant never blocks a buyable product.
        var crLiveVariant = entry.buyableVariantId || entry.availableVariantId || entry.variantId;
        if (crLiveVariant) button.setAttribute('data-cr-variant-id', String(crLiveVariant));
        button.setAttribute('data-cr-available', (entry.buyableVariantId || entry.availableVariantId || entry.productAvailable || entry.available) ? 'true' : 'false');

        var thumbImg = button.querySelector('.car-results__shade-thumb img');
        if (thumbImg && entry.image) {
          thumbImg.src = entry.image;
          thumbImg.alt = entry.title || '';
        }
        var nameEl = button.querySelector('.car-results__shade-name');
        if (nameEl) nameEl.textContent = staticShadeName(shadeKey);

        // If this card is the currently selected shade, reflect it in the
        // showcase + summary/pricing column right away.
        if (button.classList.contains('is-active')) {
          if (entry.image && stageImg) {
            stageImg.src = entry.image;
            stageImg.alt = entry.title || '';
          }
          if (shadeName) shadeName.textContent = staticShadeName(shadeKey);
          if (entry.description && shadeDesc) shadeDesc.innerHTML = entry.description;
          var qtyEl = root.querySelector('[data-cr-qty-value]');
          var qty = parseInt(String(qtyEl ? qtyEl.textContent : '1').replace(/[^0-9]/g, ''), 10) || 1;
          if (shadePrice) shadePrice.textContent = staticShadePrice(shadeKey, qty);
        }
      });

      refreshStockStatus();
    }

    // Run once the rest of this script has queried the DOM references this
    // renderer depends on (stageImg, shadeName, shadePrice, quantity).
    window.setTimeout(renderDynamicShades, 0);

    // ------------------------------------------------------------------
    // Universal Front Windshield Shade / Rear Windshield Shade cards.
    //
    // Unlike Full/Half these two products fit every car, so they are
    // rendered from the data-car-results-universal island without any
    // `Compatible Car Models` matching. Same UI treatment as the dynamic
    // Full/Half cards: image, title, price (and variant id for Add to
    // cart) all come from the live Shopify product records.
    // ------------------------------------------------------------------
    function renderUniversalShades() {
      var universalData = universalIslandData;
      if (!universalData) return;

      ['front', 'rear'].forEach(function (shadeKey) {
        var entry = universalData[shadeKey];
        if (!entry || !entry.found) return;

        var button = root.querySelector('[data-shade-key="' + shadeKey + '"]');
        if (!button) return;

        // Record the live entry so the selection handler can reuse it
        // (description + currency-aware price).
        dynamicShades[shadeKey] = entry;
        // Front/Rear availability: the Admin field on the selected Car Model
        // (front_windshield_shade / rear_windshield_shade) must be TRUE AND an
        // exact matching vehicle variant must exist. When the shade is not
        // enabled we never resolve a variant, so another vehicle's Front/Rear
        // variant can never be substituted.
        var universalVehicleVariant = frontRearEnabledFor(selectedModel, shadeKey)
          ? matchedUniversalVehicleVariant(entry)
          : null;
        stockModes[shadeKey] = universalVehicleVariant
          ? availabilityModeForVariant(universalVehicleVariant)
          : 'unavailable';

        button.setAttribute('data-shade-name', staticShadeName(shadeKey));
        button.setAttribute('data-shade-price', staticShadePrice(shadeKey, 1));
        if (entry.image) button.setAttribute('data-shade-image', entry.image);
        // Prefer a confirmed buyable variant (scanned from the variant list,
        // then first_available_variant) over the default variant so a
        // sold-out first/default variant never blocks a buyable product.
        if (universalVehicleVariant && universalVehicleVariant.id) {
          button.setAttribute('data-cr-variant-id', String(universalVehicleVariant.id));
          button.setAttribute('data-cr-available', universalVehicleVariant.available ? 'true' : 'false');
        } else {
          button.removeAttribute('data-cr-variant-id');
          button.setAttribute('data-cr-available', 'false');
        }

        var thumbImg = button.querySelector('.car-results__shade-thumb img');
        if (thumbImg && entry.image) {
          thumbImg.src = entry.image;
          thumbImg.alt = entry.title || '';
        }
        var nameEl = button.querySelector('.car-results__shade-name');
        if (nameEl) nameEl.textContent = staticShadeName(shadeKey);

        // If this card is the currently selected shade, reflect it in the
        // showcase + summary/pricing column right away.
        if (button.classList.contains('is-active')) {
          if (entry.image && stageImg) {
            stageImg.src = entry.image;
            stageImg.alt = entry.title || '';
          }
          if (shadeName) shadeName.textContent = staticShadeName(shadeKey);
          if (entry.description && shadeDesc) shadeDesc.innerHTML = entry.description;
          var qtyEl = root.querySelector('[data-cr-qty-value]');
          var qty = parseInt(String(qtyEl ? qtyEl.textContent : '1').replace(/[^0-9]/g, ''), 10) || 1;
          if (shadePrice) shadePrice.textContent = staticShadePrice(shadeKey, qty);
        }
      });

      refreshStockStatus();
    }

    window.setTimeout(renderUniversalShades, 0);

    // Graceful fallback: if the initially-selected shade (Full) has no
    // hydrated live product - e.g. when the selected car is not listed in
    // the product's Compatible Car Models - populate the showcase with that
    // card's configured placeholder so the stage is never left blank. This
    // runs AFTER both hydration passes, so no default/demo car image can
    // flash before the dynamic data has had its chance to resolve.
    window.setTimeout(function () {
      if (!stageImg || stageImg.getAttribute('src')) return;
      var active = activeShade();
      if (!active) return;
      var fallbackImage = active.getAttribute('data-shade-image');
      if (fallbackImage) {
        stageImg.src = fallbackImage;
        stageImg.alt = active.getAttribute('data-shade-name') || '';
      }
    }, 0);

    function yearsLabel(model) {
      if (!model || !model.yearRange) return '';
      return normalizeRange(model.yearRange).replace('-', ' - ');
    }

    function rangeContainsYear(rangeValue, year) {
      if (!year) return false;
      var range = parseRange(rangeValue);
      if (!range.start) return false;
      return year >= range.start && year <= range.end;
    }

    // ------------------------------------------------------------------
    // Header / identity panel
    // ------------------------------------------------------------------
    var titleBrand = root.querySelector('[data-cr-title-brand]');
    var titleModel = root.querySelector('[data-cr-title-model]');
    var chipYear = root.querySelector('[data-cr-chip-year]');
    var stageImg = root.querySelector('.car-results__stage-img');
    var fullsizeBtn = root.querySelector('[data-cr-fullsize]');

    document.title = 'Car Results';

    if (titleBrand) {
      titleBrand.textContent = brandRecord && brandRecord.name
        ? brandRecord.name
        : titleBrand.textContent;
    }

    if (titleModel) {
      if (selectedModel && selectedModel.cleanName) {
        titleModel.textContent = selectedModel.cleanName;
        titleModel.hidden = false;
      } else if (modelParam) {
        titleModel.textContent = modelParam.replace(/-/g, ' ').replace(/\b\w/g, function (m) { return m.toUpperCase(); });
        titleModel.hidden = false;
      }
    }

    if (chipYear) {
      var chipText = '';
      if (selectedModel) chipText = yearsLabel(selectedModel);
      else if (yearParam) chipText = String(yearParam);
      if (chipText) {
        chipYear.textContent = chipText;
        chipYear.hidden = false;
      }
    }

    // NOTE: the showcase image is intentionally NOT set from the selected
    // car model's metaobject image here. The stage starts empty (no static
    // src) and is populated only when the initially-selected Full Window
    // Coverage product hydrates in renderDynamicShades - this prevents
    // any default/demo car image from flashing on initial page load.

    // ------------------------------------------------------------------
    // Shade selection - swaps the showcase image and updates the summary
    // ------------------------------------------------------------------
    var shadeButtons = Array.prototype.slice.call(root.querySelectorAll('.car-results__shade'));
    var shadeName = root.querySelector('[data-cr-shade-name]');
    var shadePrice = root.querySelector('[data-cr-price]');
    var qtyValue = root.querySelector('[data-cr-qty-value]');
    var minusBtn = root.querySelector('[data-cr-qty-minus]');
    var plusBtn = root.querySelector('[data-cr-qty-plus]');
    var buyForm = root.querySelector('.car-results__buy');
    var addBtn = root.querySelector('[data-cr-add]');
    var shadeDesc = root.querySelector('[data-cr-desc]');
    var defaultShadeDesc = shadeDesc ? shadeDesc.innerHTML : '';
    var quantity = 1;

    // shadeKey -> matched live product entry (full/half)
    var dynamicShades = {};

    // shadeKey -> availability presentation mode of the selected shade:
    //   'in-stock'    - Shopify confirms a buyable variant with stock on hand
    //   'on-order'    - Shopify confirms a buyable variant at 0 tracked
    //                   inventory (custom-made on order) - shows the
    //                   AVAILABLE ON ORDER status
    //   'unavailable' / 'none' - existing unavailable behavior (gate only)
    var stockModes = {};
    var stockStatus = root.querySelector('[data-cr-stock]');
    var advancePaymentNote = root.querySelector('[data-cr-advance-payment]');
    var unavailableNote = root.querySelector('[data-cr-unavailable]');

    // ------------------------------------------------------------------
    // Out of Stock modal - unavailable Front/Rear Windshield Shade notice.
    // The modal markup lives in this snippet; Liquid renders the translated
    // strings into it and the script reuses the title text for the disabled
    // Add to cart button label (script blocks cannot render Liquid).
    // ------------------------------------------------------------------
    var oodModal = root.querySelector('[data-cr-ood-modal]');
    var oodModalCard = oodModal ? oodModal.querySelector('.car-results__modal-card') : null;
    var oodModalTitle = root.querySelector('[data-cr-ood-title]');
    var oodLastFocus = null;
    var addBtnDefaultLabel = addBtn ? addBtn.textContent : '';

    function oodShadeBlocked(shadeKey) {
      if (shadeKey !== 'front' && shadeKey !== 'rear') return false;
      var mode = stockModes[shadeKey];
      return mode !== 'in-stock' && mode !== 'on-order';
    }

    function oodKeyHandler(event) {
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        event.preventDefault();
        oodCloseModal();
      }
    }

    function oodOpenModal() {
      if (!oodModal || !oodModal.hidden) return;
      oodLastFocus = document.activeElement;
      oodModal.hidden = false;
      document.body.classList.add('car-results-modal-open');
      var okBtn = oodModal.querySelector('[data-cr-ood-ok]');
      if (okBtn) okBtn.focus();
      document.addEventListener('keydown', oodKeyHandler);
    }

    function oodCloseModal() {
      if (!oodModal || oodModal.hidden) return;
      oodModal.hidden = true;
      document.body.classList.remove('car-results-modal-open');
      document.removeEventListener('keydown', oodKeyHandler);
      if (oodLastFocus && typeof oodLastFocus.focus === 'function') {
        try { oodLastFocus.focus(); } catch (error) { /* focus restore is best-effort */ }
      }
      oodLastFocus = null;
    }

    if (oodModal) {
      var oodOkBtn = oodModal.querySelector('[data-cr-ood-ok]');
      var oodCloseBtn = oodModal.querySelector('[data-cr-ood-close]');
      if (oodOkBtn) oodOkBtn.addEventListener('click', oodCloseModal);
      if (oodCloseBtn) oodCloseBtn.addEventListener('click', oodCloseModal);
      // Click outside the white card (dark overlay or padding) also closes.
      oodModal.addEventListener('click', function (event) {
        if (oodModalCard && !oodModalCard.contains(event.target)) oodCloseModal();
      });
    }

    function availabilityMode(entry) {
      if (!entry) return 'none';
      var buyableId = entry.buyableVariantId || entry.availableVariantId;
      if (!buyableId) return 'unavailable';
      var tracked = String(entry.inventoryManagement || '').toLowerCase() === 'shopify';
      var stock = typeof entry.inventoryQuantity === 'number' ? entry.inventoryQuantity : null;
      if (tracked && stock !== null && stock <= 0) return 'on-order';
      return 'in-stock';
    }

    function availabilityModeForVariant(variant) {
      if (!variant || !variant.id || variant.available === false) return 'unavailable';
      var tracked = String(variant.inventoryManagement || '').toLowerCase() === 'shopify';
      var stock = typeof variant.inventoryQuantity === 'number' ? variant.inventoryQuantity : null;
      if (tracked && stock !== null && stock <= 0) return 'on-order';
      return 'in-stock';
    }

    function refreshStockStatus() {
      var active = activeShade();
      var key = active ? (active.getAttribute('data-shade-key') || '') : '';
      if (stockStatus) stockStatus.hidden = stockModes[key] !== 'on-order';
      if (advancePaymentNote) advancePaymentNote.hidden = key !== 'front' && key !== 'rear';

      // Front/Rear unavailable for the selected vehicle: show the message and
      // disable Add to Cart. Full/Half shades are never affected.
      var frontRearBlocked = (key === 'front' || key === 'rear') &&
        stockModes[key] !== 'in-stock' && stockModes[key] !== 'on-order';
      if (unavailableNote) unavailableNote.hidden = !frontRearBlocked;
      if (addBtn) addBtn.disabled = !!frontRearBlocked;

      // Re-label the Add to cart button while a Front/Rear shade is blocked:
      // "Out of Stock" instead of "Add to cart" (CSS uppercases it). Full/Half
      // and available Front/Rear shades keep the normal label.
      if (addBtn) {
        var oodLabel = oodModalTitle ? oodModalTitle.textContent : 'Out of Stock';
        var nextLabel = frontRearBlocked ? oodLabel : addBtnDefaultLabel;
        if (nextLabel && addBtn.textContent !== nextLabel) addBtn.textContent = nextLabel;
      }
    }

    // Shade tab UI references - the "side" group tab owns the Full/Half
    // sub-tabs; "rear"/"front" are single-shade tabs.
    var tabButtons = Array.prototype.slice.call(root.querySelectorAll('[data-cr-tab]'));
    var subtabButtons = Array.prototype.slice.call(root.querySelectorAll('[data-cr-subtab]'));
    var subtabsWrap = root.querySelector('[data-cr-subtabs]');

    function moneyParts(money) {
      var s = String(money || '');
      var m = /^([^\d]*)([\d.,]+)(.*)$/.exec(s);
      if (!m) return { prefix: '', amount: 0, suffix: '' };
      return {
        prefix: m[1],
        amount: parseFloat(m[2].replace(/[^0-9.]/g, '')),
        suffix: m[3]
      };
    }

    function formatMoney(money, qty) {
      var p = moneyParts(money);
      var total = p.amount * (qty || 1);
      var num = total.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return p.prefix + num + p.suffix;
    }

    function activeShade() {
      for (var s = 0; s < shadeButtons.length; s++) {
        if (shadeButtons[s].classList.contains('is-active')) return shadeButtons[s];
      }
      return null;
    }

    function activeShadeMoney() {
      var shade = activeShade();
      return shade ? shade.getAttribute('data-shade-price') || '' : '';
    }

    function refreshTotal() {
      var shade = activeShade();
      if (shadePrice) shadePrice.textContent = staticShadePrice(shade ? shade.getAttribute('data-shade-key') : '', quantity);
    }

    function setQuantity(next) {
      quantity = Math.min(99, Math.max(1, next));
      if (qtyValue) qtyValue.textContent = String(quantity);
      refreshTotal();
    }

    // Normal shade selection: activates the clicked card/tab, swaps the
    // showcase image/name/description and refreshes totals + availability.
    // Shared by every shade click (available or not) so the selected-shade
    // UI/state is always driven by this single code path.
    function selectShade(button) {
      shadeButtons.forEach(function (other) {
        var isActive = other === button;
        other.classList.toggle('is-active', isActive);
        other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      var shadeImage = button.getAttribute('data-shade-image');
      if (shadeImage && stageImg) {
        stageImg.src = shadeImage;
        stageImg.alt = button.getAttribute('data-shade-name') || '';
      }
      if (shadeName) shadeName.textContent = staticShadeName(button.getAttribute('data-shade-key'));

      // Full/Half live products show their Shopify description; all other
      // shades keep the static demo description.
      if (shadeDesc) {
        var dynamicEntry = dynamicShades[button.getAttribute('data-shade-key')];
        shadeDesc.innerHTML = (dynamicEntry && dynamicEntry.description)
          ? dynamicEntry.description
          : defaultShadeDesc;
      }

      reflectTabsForShadeKey(button.getAttribute('data-shade-key'));

      refreshTotal();
      refreshStockStatus();
    }

    shadeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var blocked = oodShadeBlocked(button.getAttribute('data-shade-key') || '');

        // Selection and availability are independent states: the clicked
        // shade always becomes the selected one (same active styling,
        // preview and content as a normal selection)...
        selectShade(button);

        // ...then an unavailable Front/Rear shade additionally opens the
        // Out of Stock modal. Add to cart stays disabled in that state;
        // after closing the modal the unavailable shade remains selected.
        if (blocked) oodOpenModal();
      });
    });

    // ------------------------------------------------------------------
    // Shade tab UI - the three category tabs sit directly below the
    // Premium Quality note in the details column and drive the exact same
    // selection path as the rail cards: a tab/sub-tab click re-activates
    // the matching rail shade button (data-shade-key), so the showcase
    // image, title, price, variant id and availability all come from the
    // existing Shopify product data - no separate resolution logic.
    //
    //   "side" (4 side coverage sunshades) owns the two Full/Half
    //   sub-tabs. Rear Window Shield / Front Window Shield are single
    //   shade tabs that hide the Full/Half sub-tabs while they are active.
    // ------------------------------------------------------------------
    function tabButtonByKey(key) {
      for (var t = 0; t < tabButtons.length; t++) {
        if (tabButtons[t].getAttribute('data-cr-tab') === key) return tabButtons[t];
      }
      return null;
    }

    function subtabButtonByKey(key) {
      for (var st = 0; st < subtabButtons.length; st++) {
        if (subtabButtons[st].getAttribute('data-cr-subtab') === key) return subtabButtons[st];
      }
      return null;
    }

    function shadeButtonByKey(key) {
      for (var s = 0; s < shadeButtons.length; s++) {
        if (shadeButtons[s].getAttribute('data-shade-key') === key) return shadeButtons[s];
      }
      return null;
    }

    function setTabActive(key) {
      var active = tabButtonByKey(key);
      tabButtons.forEach(function (tab) {
        var isOn = tab === active;
        tab.classList.toggle('is-active', isOn);
        tab.setAttribute('aria-selected', isOn ? 'true' : 'false');
      });
    }

    function setSubtabActive(key) {
      var active = subtabButtonByKey(key);
      subtabButtons.forEach(function (st) {
        var isOn = st === active;
        st.classList.toggle('is-active', isOn);
        st.setAttribute('aria-selected', isOn ? 'true' : 'false');
      });
    }

    // Keep the tab/sub-tab UI in sync with whichever shade is selected.
    function reflectTabsForShadeKey(key) {
      if (key === 'full' || key === 'half') {
        setTabActive('side');
        setSubtabActive(key);
        if (subtabsWrap) subtabsWrap.hidden = false;
      } else if (key === 'rear' || key === 'front') {
        setTabActive(key);
        if (subtabsWrap) subtabsWrap.hidden = true;
      }
    }

    function activeSubtabKey() {
      var fallback = 'full';
      for (var st = 0; st < subtabButtons.length; st++) {
        if (subtabButtons[st].classList.contains('is-active')) {
          fallback = subtabButtons[st].getAttribute('data-cr-subtab') || fallback;
        }
      }
      return fallback;
    }

    tabButtons.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabKey = tab.getAttribute('data-cr-tab');
        var shadeBtn = shadeButtonByKey(tabKey);
        if (tabKey === 'side') {
          // Re-show the Full/Half sub-tabs. If a Rear/Front shade was
          // active (sub-tabs hidden) fall back to the default FULL sub-tab;
          // otherwise keep the currently active Full/Half selection.
          if (subtabsWrap && subtabsWrap.hidden) {
            setSubtabActive('full');
            shadeBtn = shadeButtonByKey('full');
          } else {
            shadeBtn = shadeButtonByKey(activeSubtabKey());
          }
        }
        if (shadeBtn) shadeBtn.click();
      });
    });

    subtabButtons.forEach(function (st) {
      st.addEventListener('click', function () {
        var shadeBtn = shadeButtonByKey(st.getAttribute('data-cr-subtab'));
        if (shadeBtn) shadeBtn.click();
      });
    });

    if (minusBtn) minusBtn.addEventListener('click', function () { setQuantity(quantity - 1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { setQuantity(quantity + 1); });

    // View full size - opens the current showcase image in a new tab.
    if (fullsizeBtn && stageImg) {
      fullsizeBtn.addEventListener('click', function () {
        var url = stageImg.currentSrc || stageImg.src;
        if (url) window.open(url, '_blank', 'noopener');
      });
    }

    // ------------------------------------------------------------------
    // Selected-car line item properties. The car is already resolved above
    // (selectedModel / brandRecord - the exact data the Car Results page
    // displays), so it is attached to the cart line at add-to-cart time.
    // Underscore-prefixed keys stay hidden from Shopify checkout/emails
    // while remaining readable from /cart.js - the drawer renders them
    // cleanly. No car data is hardcoded and the drawer never re-resolves
    // the model from the URL.
    // ------------------------------------------------------------------
    function buildCarLineProperties() {
      var props = {};
      if (!selectedModel) return props;
      var brandName = brandRecord && brandRecord.name ? String(brandRecord.name).trim() : '';
      var modelName = selectedModel.cleanName || selectedModel.name || '';
      var years = selectedModel.yearRange
        ? normalizeRange(selectedModel.yearRange).replace('-', '\u2013')
        : '';
      if (brandName) props._car_brand = brandName;
      if (modelName) props._car_model = modelName;
      if (years) props._car_years = years;
      if (selectedModel.handle) props._car_model_handle = String(selectedModel.handle);
      return props;
    }

    // Add to cart - posts the selected shade's live variant to /cart/add.js
    // using its real variant id and quantity, then opens the cart drawer to
    // show the actual Shopify cart. All product data (variant id, price,
    // image, title) comes from the live Shopify product records hydrated
    // onto the shade buttons - nothing is hardcoded and no fake "Added"
    // feedback is shown.
    if (buyForm) {
      buyForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!addBtn || addBtn.disabled) return;

        var active = activeShade();
        var key = active ? (active.getAttribute('data-shade-key') || '') : '';

        if (!active || !key) {
          console.error('ADD TO CART: no active shade found', { active: active, shadeButtons: shadeButtons.length });
          return;
        }

        // Live variant id - prefer the attribute hydrated by the async
        // renderers, then fall back to the same Shopify data islands so the
        // value resolves deterministically for every card.
        var variantId = active.getAttribute('data-cr-variant-id') || '';
        var availableAttr = active.getAttribute('data-cr-available');
        var islandEntry = null;
        var vehicleVariant = null;

        if (key === 'full' || key === 'half') {
          islandEntry = matchedCompatEntry(key);
          vehicleVariant = matchedVehicleVariant(islandEntry);
          if (vehicleVariant && vehicleVariant.id) variantId = String(vehicleVariant.id);
        } else if (key === 'front' || key === 'rear') {
          islandEntry = (universalIslandData && universalIslandData[key]) || null;
          // Gate by the Admin availability field on the selected Car Model
          // AND an exact matching vehicle variant - a Front/Rear product must
          // never fall back to a different vehicle's variant. If the shade is
          // not enabled (or not provisioned), leave the request without a
          // variant so the availability gate rejects it.
          vehicleVariant = frontRearEnabledFor(selectedModel, key)
            ? matchedUniversalVehicleVariant(islandEntry)
            : null;
          variantId = vehicleVariant && vehicleVariant.id ? String(vehicleVariant.id) : '';
        }

        // The islands flag the variants Shopify confirms as buyable for the
        // product: `buyableVariantId` is scanned straight from the variant
        // list (first variant with available == true) and
        // `availableVariantId` is the product's first_available_variant.
        // Prefer a confirmed buyable variant over the default variant so a
        // sold-out first/default variant never blocks a genuinely-buyable
        // product. When no buyable variant exists the availability gate
        // below keeps rejecting - nothing is force-added.
        var buyableVariant = islandEntry ? String(islandEntry.buyableVariantId || islandEntry.availableVariantId || '') : '';
        var requiresVehicleVariant = key === 'front' || key === 'rear';
        if (!requiresVehicleVariant && !variantId) {
          variantId = String(buyableVariant || (islandEntry && islandEntry.variantId) || '');
        }

        var isAvailable = requiresVehicleVariant
          ? Boolean(vehicleVariant && vehicleVariant.id)
          : (Boolean(buyableVariant) ||
          ((availableAttr === null || availableAttr === undefined || availableAttr === '')
            ? (islandEntry ? islandEntry.available !== false : true)
            : availableAttr !== 'false'));

        if (vehicleVariant) isAvailable = vehicleVariant.available !== false;

        console.debug('[Car Results] Vehicle variant match', {
          selectedVehicle: selectedVehicleLabel(),
          selectedVehicleOption: selectedVehicleOptionLabel(),
          matchedVariantTitle: vehicleVariant ? vehicleVariant.title : null,
          matchedVariantId: vehicleVariant ? vehicleVariant.id : null
        });

        console.debug('[Car Results] Add to cart trace', {
          shadeKey: key,
          shadeName: active.getAttribute('data-shade-name'),
          activeClass: active.className,
          ariaPressed: active.getAttribute('aria-pressed'),
          variantAttr: active.getAttribute('data-cr-variant-id'),
          availableAttr: availableAttr,
          islandVariantId: islandEntry ? islandEntry.variantId : null,
          resolvedVariantId: variantId || null,
          quantity: quantity
        });

        if (!variantId) {
          console.error('ADD TO CART: missing variant ID', {
            shadeKey: key,
            shadeName: active.getAttribute('data-shade-name'),
            shadeImage: active.getAttribute('data-shade-image'),
            shadePrice: active.getAttribute('data-shade-price'),
            variantAttr: active.getAttribute('data-cr-variant-id'),
            availableAttr: availableAttr,
            islandEntry: islandEntry,
            compatIslandPresent: !!document.querySelector('[data-car-compat-test]'),
            universalIslandPresent: !!document.querySelector('[data-car-results-universal]')
          });
          return;
        }

        if (!isAvailable) {
          console.error('ADD TO CART: selected variant is not available', {
            shadeKey: key,
            variantId: variantId,
            availableAttr: availableAttr,
            islandAvailable: islandEntry ? islandEntry.available : null
          });
          return;
        }

        addBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId, 10),
              quantity: quantity,
              properties: buildCarLineProperties()
            }]
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed: ' + response.status);
            return response.json();
          })
          .then(function (cart) {
            console.debug('[Car Results] Add to cart success', {
              shadeKey: key,
              variantId: variantId,
              quantity: quantity,
              cartItemCount: cart.item_count,
              cartTotalPrice: cart.total_price
            });

            // Re-enable so repeated adds keep working (fixes a stuck-disabled
            // button after the first successful add).
            addBtn.disabled = false;

            // Open the existing cart drawer; it re-fetches /cart.js so the
            // newly added item and the real cart totals are displayed.
            if (window.AutoDrapeCart) {
              if (window.AutoDrapeCart.refresh) window.AutoDrapeCart.refresh();
              if (window.AutoDrapeCart.open) window.AutoDrapeCart.open();
            } else {
              console.error('ADD TO CART: cart drawer (window.AutoDrapeCart) not found - navigating to /cart instead');
              window.location.href = '/cart';
            }
          })
          .catch(function (error) {
            console.error('ADD TO CART: /cart/add.js request failed', {
              shadeKey: key,
              variantId: variantId,
              quantity: quantity,
              error: error
            });
            addBtn.disabled = false;
          });
      });
    }

    refreshTotal();
    refreshStockStatus();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCartDrawer() {
      var root = document.querySelector('[data-cart-drawer]');
      if (!root) return;

      var itemsNode = root.querySelector('[data-cart-items]');
      var emptyNode = root.querySelector('[data-cart-empty]');
      var footNode = root.querySelector('[data-cart-foot]');
      var totalNode = root.querySelector('[data-cart-total]');
      var subtotalNode = root.querySelector('[data-cart-subtotal]');
      var countNode = root.querySelector('[data-cart-count]');
      var advancePaymentNode = root.querySelector('[data-cart-advance-payment]');
      var closeBtn = root.querySelector('[data-cart-close]');
      var iso = root.getAttribute('data-cart-currency') || 'USD';
      var decLabel = root.getAttribute('data-dec-label') || 'Decrease quantity';
      var incLabel = root.getAttribute('data-inc-label') || 'Increase quantity';
      var removeLabel = root.getAttribute('data-remove-label') || 'Remove';
      var lastFocus = null;

      function money(cents) {
        var amount = (cents || 0) / 100;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: iso,
            minimumFractionDigits: 2
          }).format(amount);
        } catch (error) {
          return amount.toFixed(2);
        }
      }

      function esc(value) {
        var div = document.createElement('div');
        div.textContent = value == null ? '' : String(value);
        return div.innerHTML;
      }

      function requiresWindshieldAdvancePayment(item) {
        var handle = String(item.handle || '').toLowerCase();
        var title = String(item.product_title || item.title || '').trim().toLowerCase();
        return handle === 'front-windshield-shade' ||
          title === 'front windshield shade' ||
          title === 'rear windshield shade';
      }

      // ------------------------------------------------------------------
      // Car information is NOT guessed from the page URL here. It travels
      // ON each cart line as hidden line item properties (_car_brand,
      // _car_model, _car_years) set at add-to-cart time by
      // car-results-content.liquid, so every item keeps exactly the car
      // that was selected when it was added.
      // ------------------------------------------------------------------

      function updateCount(count) {
        var badges = document.querySelectorAll('.ad-header__cart-count');
        for (var i = 0; i < badges.length; i++) {
          badges[i].textContent = String(count || 0);
        }
      }

      function renderCart(cart) {
        updateCount(cart.item_count);
        var items = cart.items || [];
        var itemCount = items.length;
        var hasWindshieldAdvancePayment = items.some(requiresWindshieldAdvancePayment);

        itemsNode.innerHTML = '';
        emptyNode.hidden = itemCount > 0;
        footNode.hidden = itemCount === 0;
        if (advancePaymentNode) advancePaymentNode.hidden = !hasWindshieldAdvancePayment;

        if (countNode) {
          countNode.textContent = String(cart.item_count || 0);
        }
        if (subtotalNode) {
          subtotalNode.textContent = money(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
        }
        if (totalNode) {
          totalNode.textContent = money(cart.total_price);
        }

        items.forEach(function (item, index) {
          var line = index + 1;
          var img = item.image || (item.featured_image && item.featured_image.src) || '';
          var title = item.product_title || item.title || '';
          var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          var typeLine = variantTitle || (item.product_type && item.product_type !== title ? item.product_type : '');

          // Per-line car info from the line item properties set at
          // add-to-cart time - each item shows its own selected car.
          var props = item.properties || {};
          var carName = ((props._car_brand || '') + ' ' + (props._car_model || '')).trim();
          var carYears = props._car_years || '';
          var imgTag = img
            ? '<img class="ad-cart__item-img" src="' + esc(img) + '" alt="' + esc(title) + '" loading="lazy">'
            : '<div class="ad-cart__item-img"></div>';

          var row = document.createElement('div');
          row.className = 'ad-cart__item';
          row.innerHTML =
            imgTag +
            '<div class="ad-cart__item-info">' +
              '<p class="ad-cart__item-title">' + esc(title) + '</p>' +
              (carName ? '<p class="ad-cart__item-meta">' + esc(carName) + '</p>' : '') +
              (carYears ? '<p class="ad-cart__item-meta ad-cart__item-meta--muted">' + esc(carYears) + '</p>' : '') +
              (typeLine ? '<p class="ad-cart__item-variant">' + esc(typeLine) + '</p>' : '') +
              '<p class="ad-cart__item-price">' + esc(money(item.price)) + '</p>' +
              '<div class="ad-cart__qty">' +
                '<button type="button" data-cart-dec aria-label="' + esc(decLabel) + '">&#8722;</button>' +
                '<span class="ad-cart__qty-value">' + String(item.quantity) + '</span>' +
                '<button type="button" data-cart-inc aria-label="' + esc(incLabel) + '">+</button>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="ad-cart__remove" data-cart-remove aria-label="' + esc(removeLabel) + '">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16"></path><path d="M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2"></path><path d="M6 7l1 12a1 1 0 001 1h8a1 1 0 001-1l1-12"></path></svg>' +
            '</button>';

          var dec = row.querySelector('[data-cart-dec]');
          var inc = row.querySelector('[data-cart-inc]');
          var remove = row.querySelector('[data-cart-remove]');

          dec.addEventListener('click', function () {
            changeQuantity(line, Math.max(0, item.quantity - 1));
          });

          inc.addEventListener('click', function () {
            changeQuantity(line, Math.min(99, item.quantity + 1));
          });

          remove.addEventListener('click', function () {
            changeQuantity(line, 0);
          });

          itemsNode.appendChild(row);
        });
      }

      function changeQuantity(line, quantity) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart change failed');
            return response.json();
          })
          .then(function (cart) {
            iso = cart.currency || iso;
            renderCart(cart);
          })
          .catch(function () {
            refresh();
          });
      }

      function refresh() {
        fetch('/cart.js', {
          headers: { 'Accept': 'application/json' }
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            iso = cart.currency || iso;
            renderCart(cart);
          })
          .catch(function () {});
      }

      function open() {
        lastFocus = document.activeElement;
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        refresh();
        window.setTimeout(function () {
          if (closeBtn && closeBtn.focus) closeBtn.focus();
        }, 350);
      }

      function close() {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        window.setTimeout(function () {
          if (lastFocus && lastFocus.focus && document.contains(lastFocus)) {
            lastFocus.focus();
          }
        }, 380);
      }

      // Header cart icon opens the drawer instead of navigating to /cart.
      document.addEventListener('click', function (event) {
        var trigger = event.target.closest ? event.target.closest('.ad-header__cart') : null;
        if (trigger) {
          event.preventDefault();
          open();
        }
      });

      // Close button, overlay and "Continue shopping" all close the drawer.
      var closeEls = root.querySelectorAll('[data-cart-close]');
      for (var i = 0; i < closeEls.length; i++) {
        closeEls[i].addEventListener('click', close);
      }

      // Escape key closes the drawer.
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && root.classList.contains('is-open')) {
          close();
        }
      });

      // Keep the drawer and header badge in sync with the live cart.
      refresh();

      window.AutoDrapeCart = {
        open: open,
        close: close,
        refresh: refresh
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartDrawer);
    } else {
      initCartDrawer();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    var button = document.querySelector('[data-scroll-top]');
    if (!button) return;

    function updateVisibility() {
      button.hidden = window.scrollY < 300;
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    updateVisibility();
  })();
  } catch(e) { console.error(e); }
})();

})();
